import { Invalidation } from '@/classes/rules/Invalidation';
import { UsageStatus } from '@/classes/rules/UsageStatus';

interface ConstructorOptions {
  sizing?: boolean;
  preSizing?: boolean;
  pvCurve?: boolean;
}

export class FieldUsage {
  private readonly sizing: boolean;
  private readonly preSizing: boolean;
  private readonly pvCurve: boolean;

  constructor(options: ConstructorOptions = {}) {
    this.sizing = options.sizing ?? true;
    this.preSizing = options.preSizing ?? true;
    this.pvCurve = options.pvCurve ?? false;
  }

  public getInvalidation(): Invalidation {
    return new Invalidation({
      preSizing: this.preSizing,
      sizing: this.sizing,
      pvCurve: this.pvCurve
    });
  }

  public getUsageStatus() {
    return new UsageStatus({
      preSizing: this.preSizing,
      pvCurve: this.pvCurve
    });
  }
}
